import React from 'react'
import { IBreadcrumbSecondaryItem } from '../common/BreadcrumbSecondaryItem'
import BreadcrumbsSecondary from '../common/BreadcrumbsSecondary'

const FeedbackBreadcrumbs = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const items: IBreadcrumbSecondaryItem[] = [
    {
      name: 'Home',
      url: govCMSHome,
      index: 1,
    },
    {
      name: 'About us',
      url: govCMSHome + '/about-us',
      index: 2,
    },
    {
      name: 'Contact us',
      url: govCMSHome + '/about-us/contact-us',
      index: 3,
    },
    {
      name: 'Online enquiries',
      url: govCMSHome + '/about-us/contact-us/online-enquiries',
      index: 4,
    },
  ]
  return (
    <>
      <BreadcrumbsSecondary items={items} />
    </>
  )
}

export default FeedbackBreadcrumbs
